import { fork } from 'redux-saga/effects';

import { buildRootSaga as sagaCommon } from './root.saga.common';

export const buildRootSaga = (): (() => Generator) =>
  function* rootSaga() {
    yield fork(sagaCommon());
  };
